
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> Arvind Upadhye </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm arvind-upadhye section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
			<h2>Melodies Of The  <span > Strings </span></h2>
            <p>Venu Naad</p>
            <p>By</p>
            <p>Shri. Arvind Upadhye</p>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">SHRI. ARVIND UPADHYE <span class="small-sm">09 JANUARY 2021 </span></h2>
                    <p>“The drift of wind carries its melody and slowly caresses the ear. Pierces the heart and touches
                        the core where there is the soul. Peaceful harmony prevails as if the divinity has personified
                        itself in the form of musical notes”.
                        Such is the mesmerizing effect when a renowned flutist plays his flute. Arvind Jeevan Upadhye, a
                        very well-known flutist from Vidarbha has made a remarkable name in the field of music. His
                        expertise is not only limited to Central part of India. But he has also carved a niche for
                        himself at the state and national level too. The journey of this artist is as astounding as his
                        caliber in the field of music.</p>
                    <p>He learnt the basic skills from 3 different Gurus viz. Late Pandit Shri. Ulhas Bodhankar Pandit
                        Shri Prabhakar Deshkar and Pandit Shri. Rajendra Prasanna.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/arvind-upadhye.webp"
                        alt="GHRSCF">
                </div>
            </div>
            <div class="col-lg-12 mt-3">

                <p>Recently Arvind has been awarded Pt. Prabhakar Deshkar Smruti Purskar by K.K. Bhaushaheb Shewalkar
                    Sangeet Vidyalaya. People enjoyed many times his solo flute performance and Jugalbandi with Santoor,
                    Satar, Violin, Howaiian Guitar, Sarod and Instrumental Fusion in various classsical concerts in
                    India, as well as Malayshia, Dubai and Kuwait also.</p>
                <p>Arvind has been blessed by various renowned experts in the field of music and has accompanied them in
                    various concerts and programs with professional finesse.</p>
                <p>For a die hard musician innovations are the challenges which he puts before himself to evolve highly
                    creative concepts and presentations albeit with novelty. Srujan is one such activity of Arvind
                    Upadhye which he has conceptualized to quench his thirst for novel melodious performances and also
                    to gift audience with mellifluous and intelligent musical displays. Srujan is also an organization
                    of Arvind Upadhye which presents various musical programs. “PANCHAM PASSION, Drizlling Flute, Baje
                    Re Muraliya”, “Ghanu Waje Ghunaghuna” Innovative instrumental shows.</p>
            </div>

        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-8">

                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H.RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES-ONLINE SESSION</h6>
                <h6 class="fw-bold">TOPIC : VENU NAAD</h6>
                <p>Performer: Flutist Shri Arvind Upadhye</p>
                <p>Date : Saturday, 09<sup>th</sup> January 2021</p>
                <p>Time : 6.00 pm to 6.30 pm</p>
                <p>Venue : At Your Home, On your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://www.youtube.com/watch?v=v0LJ2w-3UcQ"
                        target="_blank">https://www.youtube.com/watch?v=v0LJ2w-3UcQ</a></p>


            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/venu-nad.webp"
                        alt="GHRSCF">
                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">You can also visit</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                    YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe width="100%" height="230" src="https://www.youtube.com/embed/v0LJ2w-3UcQ" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>

        </div>

    </div>
</section>
